import { render, staticRenderFns } from "./DocumentationLinks.vue?vue&type=template&id=02937bd6"
import script from "./DocumentationLinks.vue?vue&type=script&lang=ts"
export * from "./DocumentationLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports